import React, {useState} from "react";
import { useTranslation } from "next-i18next";
import {
    Collaps,
    Expand,
    MwSmallIcon,
} from "../../components/v2/icons";
import {GetStaticProps} from "next";
import {getFirstFewPosts} from "../../lib/api";
import ProductResources from "../../components/v2/product/product-resource";
import Link from "next/link";
import Card from "../../components/v2/cards/card";
import PlatformHeroSection from "../../components/v2/common/platform-hero";
import PlatformFeatures from "../../components/v2/common/platform-feature";

export default function Alerts() {
    const { t } = useTranslation("common");

    const platformDataDrivenRaw = t('platform.alerts.features.dataDriven', { returnObjects: true }) as any
    const platformDataDriven = Array.isArray(platformDataDrivenRaw) ? platformDataDrivenRaw : []
    const resourcesRaw = t('platform.alerts.resources', { returnObjects: true }) as any
    const resources = Array.isArray(resourcesRaw) ? resourcesRaw : []

    const platformCards = t('platform.alerts.cards', { returnObjects: true }) as any[]

    const resource = [] as any[]

    return (
        <>
            <div className={"platform-main"}>
                <PlatformHeroSection
                    title={<h1><span className={"text-gradient"}>{t('platform.alerts.hero.titlePrefix')}</span>{t('platform.alerts.hero.titleSuffix')}</h1>}
                    img={"/images/platform/Maximize-uptime-with-actionable-alerts.png"}
                    imgMobile={"/images/platform/Maximize-uptime-with-actionable-alerts-mobile.webp"}
                    preloadImg
                    imgAlt={t('platform.alerts.hero.imageAlt')}
                    className={"platform-page"}
                />

                <section className={'mw-card platform-inner'}>
                    <div className={'container'}>
                        <div className={'d-flex card-items'}>
                            <div className={'card-item'}>
                                <div className={'section-tag testimonial pd-right'}><MwSmallIcon/> {t('platform.shared.benefitsTag')}</div>
                                <h2><span className={"text-gradient"}>{t('platform.alerts.section.titlePrefix')}</span>{t('platform.alerts.section.titleSuffix')}</h2>
                            </div>
                            {
                                platformCards.map((item, index) => {
                                    return <Card heading={item.heading}
                                                 description={item.description}
                                                 isHeading={item.isHeading}/>
                                })
                            }
                        </div>
                    </div>
                </section>

                <PlatformFeatures title={<h2>{t('platform.alerts.features.titlePrefix')}<span className={"text-gradient"}>{t('platform.alerts.features.titleHighlight')}</span>{t('platform.alerts.features.titleSuffix')}</h2>}
                                  dataDriven={platformDataDriven}
                                  description={t('platform.alerts.features.description')}/>

                <ProductResources resources={resources} title={t('platform.shared.resourcesTitle')}/>
            </div>
        </>
    )
}

export const getStaticProps: GetStaticProps = async () => {
    const posts = await getFirstFewPosts();
    return {
        props: {
            posts,
        },
    };
};